import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, useNavigate } from 'react-router-dom';
import withRouter from './WithRouter';
import withNavigation from './WithNavigation';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import ReactModal from 'react-modal';
import ClearIcon from '@mui/icons-material/Clear';
import Tooltip from '@mui/material/Tooltip';

import { styled } from '@mui/system';

import { displaySettings, exportKey, importKey, importPartnerKeyCert, changePassword, clearCache, revokeKey, settingsInProcess, showConfirmDialog } from '../reducers/settingsReducer'
import { exitAccount } from '../reducers/upgradeReducer'
import { webServicesUtil, logout, clearCloak, clearSolList, Processing, AppStr, KeystoreType } from 'cloak-file-sdk-web';
import { modalStyles } from '../styles/styles'

const settingsModal = modalStyles.settingsModal
const modalStyle = modalStyles.singleLineModal

const linkStyle = {
	color: '#1a53ff',
	marginLeft: '20px'
}

// Styled components
const Header = styled('div')({
	display: 'flex',
	flexDirection: 'row',
	width: '100%',
	color: '#333',
});

const HeaderTitle = styled('div')({
	width: 400,
	margin: '15px 0px 0px 10px',
	textAlign: 'left',
	fontSize: '16px',
	color: '#333',
});

const Options = styled('div')({
	width: '100%',
	height: '100%',
	margin: 'auto',
	overflowY: 'auto',
	marginTop: 10,
});

const VerticalAlign = styled('div')({
	position: 'relative',
	top: '50%',
	transform: 'translateY(-50%)',
});

const OptionTitle = styled('div')({
	width: '100%',
	height: 30,
	backgroundColor: '#e6e6e6',
	marginTop: 10,
	color: '#666',
	fontSize: 12,
});

const OptionValueDiv = styled('div')({
	width: '100%',
	height: 30,
	backgroundColor: 'transparent',
	color: '#666',
	fontSize: 12,
	marginTop: 1,
	marginBottom: 1,
});

const Action = styled('div')({
	width: '100%',
	height: 30,
	fontSize: 12,
	marginTop: 1,
	marginBottom: 1,
	cursor: 'pointer',
	color: '#1a53ff',
	'&:hover': {
		backgroundColor: '#f2f2f2',
		'@media (hover: none)': {
			backgroundColor: 'transparent',
		},
	},
});



function OptionsTitle(props) {

	const {} = props;
	let displayValue = <FormattedMessage id={props.value} />

	return (
		<OptionTitle>
			<VerticalAlign style={{ marginLeft: 10 }}>
				<label>{displayValue}</label>
			</VerticalAlign>
		</OptionTitle>
	);
}

OptionsTitle.propTypes = {
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	]),
}

const Title = OptionsTitle

function OptionValue({ value, action = false, onClick = () => {} }) {
	const user = webServicesUtil().getAuth().username;
	const account = webServicesUtil().getAuth().account;
  
	let displayValue;
	if (value === "settings.signedInAs") {
	  console.log("In Settings.js user " + user);
	  displayValue = <FormattedMessage id={value} values={{ user: user }} />;
	} else if (value === "upgrade.exitAccount") {
	  displayValue = <FormattedMessage id={value} values={{ account: account }} />;
	} else {
	  displayValue = <FormattedMessage id={value} />;
	}
  
	return (
	  <div>
		{action ? (
		  <Action onClick={onClick} style={{ marginLeft: 20, marginTop: 2, height: 30 }}>
			<VerticalAlign>
			  {displayValue}
			</VerticalAlign>
		  </Action>
		) : (
		  <OptionValueDiv style={{ marginLeft: 20, marginTop: 2, height: 30 }}>
			<VerticalAlign>
			  {displayValue}
			</VerticalAlign>
		  </OptionValueDiv>
		)}
	  </div>
	);
  }

// function OptionValue(props) {

// 	const user = webServicesUtil().getAuth().username
// 	const account = webServicesUtil().getAuth().account

// 	let displayValue
// 	if (props.value === "settings.signedInAs") {
// 		console.log("In Settings.js user " + user)
// 		displayValue = <FormattedMessage id={props.value} values={{ user: user }} />
// 	} else if (props.value === "upgrade.exitAccount") {
// 		displayValue = <FormattedMessage id={props.value} values={{ account: account }} />
// 	} else {
// 		displayValue = <FormattedMessage id={props.value} />
// 	}

// 	return (
// 		// <div className={props.action ? classes.action : classes.optionValue} >
// 		<div>
// 			{props.action ? (
// 				<Action onClick={() => props.onClick()} style={{ marginLeft: 20, marginTop: 2, height: 30 }}>
// 					<VerticalAlign>
// 						{displayValue}
// 					</VerticalAlign>
// 				</Action>
// 			) : (
// 				<OptionValueDiv style={{ marginLeft: 20, marginTop: 2, height: 30 }}>
// 					<VerticalAlign>
// 						{displayValue}
// 					</VerticalAlign>
// 				</OptionValueDiv>
// 			)
// 			}
// 		</div>
// 	);
// }

OptionValue.propTypes = {
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element,
		PropTypes.node
	]).isRequired,
	action: PropTypes.bool,
	onClick: PropTypes.func
}

// OptionValue.defaultProps = {
// 	action: false
// }

const Option = OptionValue

class Settings extends React.PureComponent {

	constructor(props) {
		super(props);
		var storedLockWhenInactive = (window.localStorage.lockWhenInactive === 'true')
		this.state = {
			lockWhenInactive: storedLockWhenInactive,
		}
	}

	componentDidMount() {
		ReactModal.setAppElement('body');

		this.props.dispatch(settingsInProcess(false, ""))

		this.props.dispatch(displaySettings(true))

		var storedLockWhenInactive = (window.localStorage.lockWhenInactive === 'true')
		console.log("In Settings bf setState storedLockWhenInactive " + storedLockWhenInactive)
		console.log("In Settings bf setState lockWhenInactive " + this.state.lockWhenInactive)
		this.setState({ lockWhenInactive: storedLockWhenInactive })
	}

	onClick() {
		this.props.dispatch(settingsInProcess(false, ""))
		this.props.dispatch(displaySettings(true))

	}

	sendExitAccount() {
		this.props.dispatch(exitAccount())
		this.props.dispatch(showConfirmDialog(false))
	}

	closeConfirmDialog() {
		this.props.dispatch(showConfirmDialog(false))
	}

	async handleCheckBox() {
		this.setState({ lockWhenInactive: !this.state.lockWhenInactive })
		console.log("state lockWhenInactive " + this.state.lockWhenInactive)
		window.localStorage.lockWhenInactive = this.state.lockWhenInactive

		let currentNavTime = new Date()
		window.localStorage.currentNavTime = currentNavTime
	}

	render() {

		const { token, showSettings, settingsInProcess, confirmDialog, accountNameReturn } = this.props
		console.log("In settings showSettings " + showSettings)

		console.log("In Settings render lockWhenInactive " + this.state.lockWhenInactive)
		console.log("In settings settingsInProcess %o", settingsInProcess)
		console.log("In settings settingsInProcess show " + settingsInProcess.show)
		console.log("In settings settingsInProcess msg " + settingsInProcess.msg)

		const message = (
			<div>
				{(settingsInProcess.show) && <FormattedMessage id={settingsInProcess.msg} />}
			</div>
		)

		const children = (
			<div>
				{
					(settingsInProcess.show) &&
					<div className="clk-modal-button-div">
						<button className="clk-modal-button" onClick={() => this.onClick()}>
							<FormattedMessage id="settings.ok" />
						</button>
					</div>
				}
			</div>
		)

		const userAccount = webServicesUtil().getAuth().account
		console.log("In Settings userAccount " + userAccount)

		const keystore = webServicesUtil().getAuth().keystore
		var partnerKeystore = false
		if (keystore === KeystoreType.CLOAK_PARTNER || keystore === KeystoreType.GATEWAY_PARTNER) {
			partnerKeystore = true
		}
		console.log("In Settings partnerKeystore " + partnerKeystore)

		return (
			<div>
				<Processing
					show={settingsInProcess.show}
					style={modalStyle}
					message={message}
					messageStyle={{ marginTop: 10, color: '#a6a6a6' }}
					children={children} />

				<ReactModal isOpen={confirmDialog} style={modalStyle}>
					<div className="clk-modal-div">
						<div className="clk-modal-content-div" style={{ marginTop: 15 }}>
							<FormattedMessage id="upgrade.confirmExitAccount" values={{ account: userAccount }} />
						</div>
						<div className="clk-modal-button-div" style={{ marginTop: 20 }}>
							<button className="clk-modal-button" onClick={() => this.closeConfirmDialog()}>
								<FormattedMessage id="solicitation.cancel" />
							</button>
							<div id="modal-pseudo-element" />
							<button className="clk-modal-button" onClick={() => this.sendExitAccount()}>
								<FormattedMessage id="solicitation.confirm" />
							</button>
						</div>
					</div>
				</ReactModal>

				<ReactModal isOpen={showSettings && Boolean(token)} style={settingsModal}>
					<div className='clk-modal-div'>
						<Header>
							<HeaderTitle>
								<FormattedMessage id="settings.settingsTitle" />
							</HeaderTitle>
							<div className="" style={{ marginLeft: 140 }}>
								<Tooltip title={<FormattedMessage id="solicitation.close" />} placement="left">
									<button className="clk-trans-button" onClick={() => this.props.navigate(-1)}>
										<ClearIcon />
									</button>
								</Tooltip>
							</div>
						</Header>

						<Options id="settingsOptions" className='settingsOptions'>

							<Title value="settings.accountTitle" />

							<Option value='settings.signedInAs' action={false} />

							<Option value='settings.changePassword' action={true} onClick={() => {
								this.props.dispatch(displaySettings(false))
								this.props.dispatch(changePassword())
							}} />
							<Option value="settings.signOut" action={true} onClick={() => {
									this.props.dispatch(displaySettings(false))
								this.props.dispatch(clearCloak())
								this.props.dispatch(clearSolList())
								this.props.dispatch(logout())

								useNavigate('/cloak/login');
							}} />

							{
								userAccount === AppStr.DEFAULT_ACCOUNT || accountNameReturn === AppStr.DEFAULT_ACCOUNT ? (
									<div>
										<br />
										<NavLink to="/cloak/upgrade" style={linkStyle}>
											<FormattedMessage id="upgrade.upgrade" />
										</NavLink>
										<br /><br />
									</div>
								) : (
									<div>
										<Option value='upgrade.exitAccount' action={true} onClick={() => {
											this.props.dispatch(showConfirmDialog(true))
										}} />
										<br />
										<a href={AppStr.CONSOLE_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
											<FormattedMessage id="upgrade.console" />
										</a>
									</div>
								)
							}

							<Title value="settings.cloakTitle" />
							<Option value='settings.exportKey' action={true} onClick={() => {
								this.props.dispatch(displaySettings(false))
								this.props.dispatch(exportKey())
							}} />
							<Option value='settings.importKey' action={true} onClick={() => {
								this.props.dispatch(displaySettings(false))
								this.props.dispatch(importKey())
							}} />
							{
								partnerKeystore &&
								<Option value='settings.importPartnerKeyCert' action={true} onClick={() => {
									this.props.dispatch(displaySettings(false))
									this.props.dispatch(importPartnerKeyCert())
								}} />
							}

							<Option value='settings.revokeKey' action={true} onClick={() => {
								this.props.dispatch(displaySettings(false))
								this.props.dispatch(revokeKey())
							}} />

							<Option value='settings.clearCache' action={true} onClick={() => {
								this.props.dispatch(displaySettings(false))
								this.props.dispatch(clearCache())
							}} />

							<table cellSpacing="0" cellPadding="0">
								<tbody>
									<tr>
										<td width="20px">
											&nbsp;
										</td>
										<td>
											<input type="checkbox" name="lockWhenInactiveCheckBox" checked={this.state.lockWhenInactive} onChange={() => this.handleCheckBox()} style={{ marginleft: 0 }} />
										</td>
										<td>
											<Option value='settings.lockWhenInactive' action={false} />
										</td>
									</tr>
								</tbody>
							</table>

						</Options>
					</div>
				</ReactModal>
			</div>
		)
	}
}

Settings.propTypes = {
	display: PropTypes.bool
}

Settings.defaultProps = {
	display: false
}

const mapStateToProps = state => {
	return {
		settingsInProcess: state.config.settingsInProcess,
		token: state.auth.token,
		confirmDialog: state.config.confirmDialog,
		showSettings: state.config.showSettings,
		accountNameReturn: state.upgrade.accountName
	}
};

export default connect(mapStateToProps)(withRouter(withNavigation(Settings)))
